import { Labelled, Modal, Stack } from "@shopify/polaris";
import React, { useCallback } from "react";
import AmazonIdeaMarkBadge from "./amazon-idea-mark-badge";
import { useAmazonIdeaCtx } from "../context";
import useTimeout from "../../../hooks/useTimeout";

export default function AmazonIdeaMarkBadgeModal({ ids, open, onClose }) {
    const { refetch } = useAmazonIdeaCtx();

    const [setDelay] = useTimeout();
    const handleCompleted = useCallback(() => {
        onClose();

        setDelay(() => {
            refetch && refetch();
        }, 1500);
    }, []);

    return (
        <Modal title="Mark Badge" sectioned open={open} onClose={onClose}>
            <Stack vertical spacing="tight">
                <Labelled label={`Badge color`} />
                <AmazonIdeaMarkBadge
                    ids={ids}
                    handleCompleted={handleCompleted}
                />
            </Stack>
        </Modal>
    );
}
